import { ListBase } from './../tools/ListBase';

class Cotizaciones extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'cotizaciones'};
    this.title = 'Cotizaciones';
    this.state.columns = [
      {
        field: 'idCotizacion',
        headerName: 'ID',
        width: 80,
      },
      {
        field: 'Nombre',
        headerName: 'Nombre',
        width: 200,
      },
      {
        field: 'Apellido',
        headerName: 'Apellido',
        width: 200,
      },
      {
        field: 'Origen',
        headerName: 'Origen',
        width: 200,
      },
      {
        field: 'Destino',
        headerName: 'Destino',
        width: 200,
      },
      {
        field: 'Estado',
        headerName: 'Estado',
        width: 200,
      },
    ];
  }

}


import { useNavigate } from 'react-router-dom';

function CotizacionesWithNavigate(props) {
  const navigate = useNavigate();
  return <Cotizaciones {...props} navigate={navigate} />;
}

export default CotizacionesWithNavigate;